import { render, staticRenderFns } from "./BadgeActionForceMassDeleteDialog.vue?vue&type=template&id=3cc4646f&"
import script from "./BadgeActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./BadgeActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports